import { PublicStatusClient, CampaignEditorFrontendStatusDto, StatusBlocked } from '@studyportals/campaign-management-api-interface';

export default class StatusChecker {
	private static client: PublicStatusClient;

	public static initialize(): void {
		this.client = new PublicStatusClient(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URL);
	}

	public static async checkStatus(): Promise<CampaignEditorFrontendStatusDto> {
		if (!this.client) {
			this.initialize();
		}

		return await this.client.getCampaignEditorFrontendStatus();
	}

	public static isBlocked(status: CampaignEditorFrontendStatusDto): status is StatusBlocked {
		return status.status === 'blocked';
	}
}
